import { h, Component } from "preact";
import { css } from "emotion";
import Image from "../components/Image";

import iconAmex from "../assets/images/icon-amex.svg";
import iconVisa from "../assets/images/icon-visa.svg";
import iconMastercard from "../assets/images/icon-mastercard.svg";
import iconZip from "../assets/images/icon-zip.png";

const iconStyle = css({
  width: 35,
  height: 25,
  marginRight: 6,
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  display: "inline-block"
});

const CardLogos = ({ event, isGlobal }) => {
  const paymentIconsStyle = {
    paddingTop: 18
  };

  const paymentIcons = [
    { icon: iconAmex, name: "American Express" },
    { icon: iconVisa, name: "Visa" },
    { icon: iconMastercard, name: "MasterCard" }
  ];

  if (!isGlobal && event.data.paymentOptions.zipMoneyEnabled) {
    paymentIcons.push({ icon: iconZip, name: "Zip Money" });
  }

  return (
    <div style={paymentIconsStyle}>
      {paymentIcons.map((icon, index) => (
        <Image
          src={icon.icon}
          className={iconStyle}
          alt={`${icon.name} logo`}
        />
      ))}
    </div>
  );
};

//<div key={index} style={style}/>
export default CardLogos;



// WEBPACK FOOTER //
// ./components/CardLogos.js